import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from "../../../atoms/Button";
import Container from "../../../atoms/Container";
import { IconClose } from "../../../atoms/Icon";
import Image from "../../../atoms/Image";
import Typography from "../../../atoms/Typography";
import colors from "../../../theme/colors";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BannerCloseStore(props) {
  const {
    id,
    isShowBanner = false,
    urlImage,
    title,
    description,
    onClickButton,
    labelButton
  } = props;
  const [isShow, setIsShow] = useState(isShowBanner);
  useEffect(() => {
    setIsShow(isShowBanner);
  }, [isShowBanner]);
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: isShow && /*#__PURE__*/_jsx(Box, {
      sx: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        background: colors.neutral.neutral8,
        position: "relative",
        zIndex: "10"
      },
      children: /*#__PURE__*/_jsx(Container, {
        sx: {
          width: "100%",
          height: "100%"
        },
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: {
              lg: "center",
              xs: "flex-start"
            },
            gap: {
              lg: "128px",
              xs: "16px"
            },
            flexDirection: {
              lg: "row",
              xs: "column"
            },
            padding: {
              lg: "48px 0 32px 0",
              xs: "44px 16px"
            },
            position: "relative"
          },
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              display: "flex",
              flexDirection: "row",
              gap: "32px",
              alignItems: "center"
            },
            children: [!!urlImage && /*#__PURE__*/_jsx(Image, {
              sx: {
                display: {
                  lg: "flex",
                  xs: "none"
                },
                width: "90px",
                height: "90px"
              },
              src: urlImage,
              alt: "logo-banner"
            }), /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                flexDirection: "column",
                gap: "4px"
              },
              children: [!!title && /*#__PURE__*/_jsx(Typography, {
                variant: "p1",
                color: colors.primary.bandaiNamcoBlack,
                sx: {
                  width: "100%",
                  lineHeight: {
                    xs: "20px",
                    lg: "26px"
                  }
                },
                dangerouslySetInnerHTML: {
                  __html: title
                }
              }), description && /*#__PURE__*/_jsx(Typography, {
                variant: "p6",
                color: colors.primary.bandaiNamcoBlack,
                sx: {
                  width: "100%",
                  lineHeight: {
                    xs: "20px",
                    lg: "22px"
                  }
                },
                dangerouslySetInnerHTML: {
                  __html: description
                }
              })]
            })]
          }), typeof onClickButton === "function" && labelButton && /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            sx: {
              background: colors.primary.bandaiNamcoBlack,
              color: colors.primary.bandaiNamcoWhite,
              minWidth: "154px",
              "&:hover": {
                background: "#000000b3"
              }
            },
            onClick: () => onClickButton?.(id),
            children: labelButton
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              position: "absolute",
              top: "24px",
              right: {
                xl: "-60px",
                lg: "-30px",
                xs: "16px"
              },
              cursor: "pointer"
            },
            onClick: () => {
              setIsShow(false);
            },
            children: /*#__PURE__*/_jsx(IconClose, {
              htmlColor: colors.primary.bandaiNamcoBlack
            })
          })]
        })
      })
    })
  });
}